import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { Box, Button, chakra, Flex, Spacer, Text } from "@chakra-ui/react";
import { LinkButton } from "../shared/generic";

export default function Pagination({ totalPages, currentPage }) {
  const prevPage = parseInt(currentPage) - 1 > 0;
  const nextPage = parseInt(currentPage) + 1 <= parseInt(totalPages);

  return (
    <chakra.nav
      gap={5}
      pt={6}
      pb={8}
      alignItems="center"
      justifyContent="space-between"
      display="flex"
    >
      {!prevPage && (
        <Button rel="previous" isDisabled leftIcon={<ChevronLeftIcon />}>
          Previous
        </Button>
      )}
      {prevPage && (
        <LinkButton
          href={currentPage - 1 === 1 ? `/blog` : `/blog/page/${currentPage - 1}`}
          rel="previous"
          leftIcon={<ChevronLeftIcon />}
        >
          Previous
        </LinkButton>
      )}
      <Text>
        Page {currentPage} of {totalPages}
      </Text>
      {!nextPage && (
        <Button rel="next" rightIcon={<ChevronRightIcon />} isDisabled>
          Next
        </Button>
      )}
      {nextPage && (
        <LinkButton
          href={`/blog/page/${currentPage + 1}`}
          rightIcon={<ChevronRightIcon />}
          rel="next"
        >
          Next
        </LinkButton>
      )}
    </chakra.nav>
  );
}
